













































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import NumberInput from "@/components/common/NumberInput.vue";
import {
  PublicMoneyBurden,
  CareSpecificationDetail,
  CareInvoice,
  CareSpecification,
  PatientBurden,
  PatientBurdenMoney
} from "@/components/careEdit/types";
import { PulldownItem, getInnerTax } from "@/types";

@Component({
  components: {
    NumberInput
  }
})
export default class CareInvoiceRev1 extends Vue {
  @Prop() invoice!: CareInvoice; //利用者向け請求書データ
  @Prop() specifications!: CareSpecification[]; ////介護給付費データ
  @Prop() tax_items!: PulldownItem[]; //税率選択アイテムリスト

  //利用者負担
  private get selfBurdens(): PatientBurden[] {
    let burdens: CareSpecificationDetail[] = [];
    this.specifications.forEach(specification => {
      if (specification.related_care_specification_id === 0) {
        burdens = burdens.concat(specification.specification_details);
      }
    });

    if (this.specifications.length == 1) {
      return burdens.map(burden => {
        return {
          service_code: Number(burden.service_code),
          service_name: String(burden.service_name),
          points: Number(burden.points),
          count: Number(burden.count)
        };
      });
    }

    //サービスコードごとにまとめる
    burdens.sort((x, y) => {
      return x.service_code - y.service_code;
    });

    const serviceBurdens: PatientBurden[] = [];
    let beforeDetail: PatientBurden | undefined = undefined;
    burdens.forEach(detail => {
      if (
        beforeDetail != undefined &&
        beforeDetail.service_code == detail.service_code
      ) {
        serviceBurdens[serviceBurdens.length - 1].count += Number(detail.count);
      } else {
        serviceBurdens.push({
          service_code: Number(detail.service_code),
          service_name: detail.service_name,
          points: Number(detail.points),
          count: Number(detail.count)
        });
      }
      beforeDetail = detail;
    });

    return serviceBurdens;
  }

  //利用者負担（サービス種類：利用料・超過分）
  private get patientBurdenMoneys(): PatientBurdenMoney[] {
    //限度額超過分は（サービス種類コード, 単位数単価）ごとに単位数を積み上げ、
    //単位数の合算後に1回だけ円換算（切り捨て）する。
    //単位数単価はページごとに手編集できるため、単価が異なるものは別グループとして丸める。
    const buckets: PatientBurdenMoney[] = [];
    this.specifications.forEach(specification => {
      //複数公費の2ページ目以降は超過分を計上しない
      const isPage1 = Number(specification.related_care_specification_id) === 0;
      specification.specification_aggregates.forEach((aggregate, i) => {
        let isHit = false;
        let burdenMoney = 0;
        specification.public_moneys.forEach(pm => {
          if (pm.public_money_rate == 100 || pm.public_money_rate == 0) {
            burdenMoney += pm.public_money_aggregates[i].patient_burden;
          }
        });

        const kindCode = Number(aggregate.service_type_kind_code);
        const place = Number(aggregate.point_place) || 0;
        //基本サービス分の限度額超過単位数
        const planPointsAboveUnits = isPage1
          ? Math.max(
              Number(aggregate.target_points) - Number(aggregate.plan_points),
              0
            )
          : 0;
        //「限度額超過分」が画面で手入力されたか（保存値が自動算出値と一致しなければ手入力）。
        //手入力された場合はその円を常に正とし、単位数の合算には参加させない。
        //ページ1限定なのは、公費ページのアグリゲートがページ1のスプレッドコピーで作られ、
        //同じ値が入って二重計上になるため。
        const isManual =
          isPage1 &&
          Number(aggregate.plan_points_above_money) !==
            Math.floor((planPointsAboveUnits * place) / 100);
        const manualMoney = isManual
          ? Number(aggregate.plan_points_above_money)
          : 0;
        //丸め対象の限度額超過単位数（手入力時は基本サービス分を除く）
        const aboveUnits = isPage1
          ? (isManual ? 0 : planPointsAboveUnits) +
            Number(aggregate.shogu_kaizen_above_units) +
            Number(aggregate.service_teikyo_above_units)
          : 0;

        buckets.forEach(bucket => {
          if (
            bucket.service_type_kind_code === kindCode &&
            bucket.point_place === place
          ) {
            bucket.money += burdenMoney;
            bucket.over_units += aboveUnits;
            bucket.over_money += manualMoney;
            isHit = true;
          }
        });
        if (!isHit) {
          buckets.push({
            service_type_kind_code: kindCode,
            service_type: aggregate.service_type,
            money: burdenMoney,
            over_money: manualMoney,
            over_units: aboveUnits,
            point_place: place
          });
        }
      });
    });

    //（サービス種類コード, 単位数単価）ごとに丸めてから、サービス種類単位で合算する
    const burdenMoneys: PatientBurdenMoney[] = [];
    buckets.forEach(bucket => {
      //手入力分（bucket.over_money に積んである円）は丸めずそのまま足す
      const overMoney =
        bucket.over_money +
        Math.floor((bucket.over_units * bucket.point_place) / 100);
      let isHit = false;
      burdenMoneys.forEach(money => {
        if (money.service_type_kind_code === bucket.service_type_kind_code) {
          money.money += bucket.money;
          money.over_units += bucket.over_units;
          money.over_money += overMoney;
          isHit = true;
        }
      });
      if (!isHit) {
        burdenMoneys.push({
          service_type_kind_code: bucket.service_type_kind_code,
          service_type: bucket.service_type,
          money: bucket.money,
          over_money: overMoney,
          over_units: bucket.over_units,
          point_place: bucket.point_place
        });
      }
    });
    return burdenMoneys;
  }

  //限度額超過分合計（保存時に請求書の合計額へ算入済みの額。CareEdit.vue が参照する）
  get aboveLimitTotal(): number {
    let totalMoney = 0;
    this.patientBurdenMoneys.forEach(burden => {
      totalMoney += burden.over_money;
    });
    return totalMoney;
  }

  //利用者負担合計
  private get patientBurdenTotal(): number {
    let totalMoney = 0;
    this.patientBurdenMoneys.forEach(burden => {
      totalMoney += burden.money + burden.over_money;
    });
    return totalMoney;
  }

  //全額自己負担合計
  private get allSelfBurdenTotal(): number {
    let money = 0;
    if (this.invoice !== null) {
      money +=
        Number(this.invoice.all_self_burden1_money) +
        Number(this.invoice.all_self_burden2_money) +
        Number(this.invoice.all_self_burden3_money);
    }
    return money;
  }

  //公費本人負担
  private get publicMoneyBurdens(): PublicMoneyBurden[] {
    const burdens: PublicMoneyBurden[] = [];
    this.specifications.forEach(specification => {
      specification.public_moneys.forEach(pm => {
        let isHit = false;
        let money = 0;

        pm.public_money_aggregates.forEach(aggregate => {
          money += aggregate.public_money_self_burden;
        });

        if (money > 0) {
          burdens.forEach(burden => {
            if (burden.public_money_law_number === pm.public_money_law_number) {
              isHit = true;
              burden.money += money;
            }
          });

          if (!isHit) {
            burdens.push({
              public_money_law_number: pm.public_money_law_number,
              public_money_name: pm.public_money_name,
              money: money
            });
          }
        }
      });
    });

    return burdens;
  }

  //公費本人負担合計
  private get publicMoneyBurdenTotal(): number {
    let money = 0;
    this.publicMoneyBurdens.forEach(burden => {
      money += burden.money;
    });
    return money;
  }

  //その他合計
  private get otherTotal(): number {
    let money = 0;
    if (this.invoice !== null) {
      money +=
        Number(this.invoice.other1_money) +
        Number(this.invoice.other2_money) +
        Number(this.invoice.other3_money) +
        Number(this.invoice.other4_money) +
        Number(this.invoice.other5_money);
    }
    return money;
  }

  //全て合計
  get allTotal(): number {
    return (
      this.patientBurdenTotal +
      this.allSelfBurdenTotal +
      this.publicMoneyBurdenTotal +
      this.otherTotal
    );
  }

  //消費税額（8%）
  get allTax8(): number {
    return this.getTax(8);
  }

  //消費税額（10%）
  get allTax10(): number {
    return this.getTax(10);
  }

  getTax(tax: number): number {
    let money = 0;
    if (this.invoice !== null) {
      if (this.invoice.other1_tax === tax) {
        money += getInnerTax(this.invoice.other1_money, tax);
      }
      if (this.invoice.other2_tax === tax) {
        money += getInnerTax(this.invoice.other2_money, tax);
      }
      if (this.invoice.other3_tax === tax) {
        money += getInnerTax(this.invoice.other3_money, tax);
      }
      if (this.invoice.other4_tax === tax) {
        money += getInnerTax(this.invoice.other4_money, tax);
      }
      if (this.invoice.other5_tax === tax) {
        money += getInnerTax(this.invoice.other5_money, tax);
      }
    }
    return money;
  }
}
